// extracted by mini-css-extract-plugin
export default {"fsCheckbox":"checkbox-module--fs-checkbox--2e2b1"};